module.exports = __webpack_public_path__ + "static/media/HindiScript.e8c2f79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HindiScript.png
// module id = 286
// module chunks = 0